"use client";

import { createContext, useContext } from "react";

export type OsLayoutContextValue = {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  /** When true, OS main content area does not scroll (child owns scroll regions). */
  mainAreaScrollLocked: boolean;
  setMainAreaScrollLocked: (locked: boolean) => void;
};

export const OsLayoutContext = createContext<OsLayoutContextValue | null>(
  null,
);

export function useOsLayout(): OsLayoutContextValue | null {
  return useContext(OsLayoutContext);
}
